if (typeof debounce === "undefined") {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get("theme-header")) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector(".header-section");
      this.menu = this.querySelector("#mobile-menu");
      this.toggle = this.querySelector(".mobile-toggle-wrapper");

      document.addEventListener("keyup", (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === "ESCAPE") {
            this.toggle.removeAttribute("open");
            this.toggle.classList.remove("active");
          }
        }
      });
      if (this.classList.contains("header-sticky--active")) {
        document.body.classList.add("header-sticky--active");
      }
      this.toggle
        .querySelector(".mobile-toggle")
        .addEventListener("click", (e) => {
          if (this.toggle.classList.contains("active")) {
            e.preventDefault();
            document.body.classList.remove("overflow-hidden");
            this.toggle.classList.remove("active");
            this.closeAnimation(this.toggle);
          } else {
            document.body.classList.add("overflow-hidden");
            setTimeout(() => {
              this.toggle.classList.add("active");
            });
          }
          window.dispatchEvent(new Event("resize.resize-select"));
        });

      // Sticky Header Class
      window.addEventListener("scroll", this.setStickyClass.bind(this), {
        passive: true,
      });

      // Mobile Menu offset
      window.addEventListener("scroll", this.setHeaderOffset.bind(this), {
        passive: true,
      });
      window.addEventListener("scroll", this.setHeaderHeight.bind(this), {
        passive: true,
      });

      window.dispatchEvent(new Event("scroll"));

      if (document.querySelector(".announcement-bar-section")) {
        window.addEventListener("scroll", this.setAnnouncementHeight(), {
          passive: true,
        });
        window.dispatchEvent(new Event("resize"));
      }

      // Buttons.
      this.menu
        .querySelectorAll("summary")
        .forEach((summary) =>
          summary.addEventListener("click", this.onSummaryClick.bind(this)),
        );
    }
    setStickyClass() {
      if (this.classList.contains("header-sticky--active")) {
        let h = this.getBoundingClientRect().top;
        if (h <= 0) {
          this.classList.add("is-sticky");
        } else {
          this.classList.remove("is-sticky");
        }
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector(".announcement-bar-section");
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty(
        "--announcement-height",
        h + "px",
      );
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty("--header-offset", h + "px");
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty("--header-height", h + "px");
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute("open");
      if (isOpen) {
        detailsElement.classList.remove("submenu-open");
      } else {
        detailsElement.classList.add("submenu-open");
      }
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest("details");
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove("submenu-open");
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute("open");
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define("theme-header", ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll(
        ".thb-full-menu .menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu",
      );
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function () {
        window.addEventListener(
          "resize",
          debounce(function () {
            _this.resizeSubMenus();
          }, 100),
        );
        _this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(
          ":scope >.menu-item-has-children>.sub-menu",
        );

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l =
              sub_submenu.parentElement.getBoundingClientRect().left +
              sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add("left-submenu");
          } else if (
            sub_submenu.parentElement.classList.contains("left-submenu")
          ) {
            sub_submenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }
  customElements.define("full-menu", FullMenu);
}

/**
 *  @class
 *  @function MainNavigation
 */
if (!customElements.get("main-navigation")) {
  class MainNavigation extends HTMLElement {
    #listenersAttached = false;
    #submenuIdCounter = 0;
    #observer = null;

    connectedCallback() {
      // Event-Delegation einmalig auf <main-navigation> setzen –
      // überlebt Globo-DOM-Re-renders, da Listener nicht auf Kindelementen hängen
      if (!this.#listenersAttached) {
        this.#attachDelegatedListeners();
        this.#listenersAttached = true;
      }

      this.#initAria();

      // Globo rendert asynchron und tauscht Teilbäume auch später noch aus
      this.#observer = new MutationObserver(
        debounce(() => this.#initAria(), 100),
      );
      this.#observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      this.#observer = null;
    }

    #initAria() {
      this.querySelectorAll(".gm-has-submenu > .gm-target").forEach((link) => {
        if (link.dataset.navAria) {
          return;
        }
        const item = link.parentElement;
        const submenu = item.querySelector(":scope > .gm-submenu");
        if (!submenu) {
          return;
        }
        if (!submenu.id) {
          submenu.id = `nav-submenu-${++this.#submenuIdCounter}`;
        }
        link.setAttribute(
          "aria-expanded",
          item.classList.contains("gm-kb-open") ? "true" : "false",
        );
        link.setAttribute("aria-controls", submenu.id);
        link.dataset.navAria = "true";
      });
    }

    #setExpanded(item, expanded) {
      item.classList.toggle("gm-kb-open", expanded);
      item
        .querySelector(":scope > .gm-target")
        ?.setAttribute("aria-expanded", expanded ? "true" : "false");

      if (!expanded) {
        item.querySelectorAll(".gm-has-submenu.gm-kb-open").forEach((child) => {
          child.classList.remove("gm-kb-open");
          child
            .querySelector(":scope > .gm-target")
            ?.setAttribute("aria-expanded", "false");
        });
      }
    }

    #closeAndRefocus(item) {
      this.#setExpanded(item, false);
      item.querySelector(":scope > .gm-target")?.focus();
    }

    #getFocusable(root) {
      if (!root) {
        return [];
      }
      return Array.from(
        root.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
        ),
        // filtert Links in geschlossenen Unterebenen aus (display:none)
      ).filter((el) => el.getClientRects().length > 0);
    }

    #topLevelTargets() {
      return Array.from(this.querySelectorAll(".gm-level-0 > .gm-target"));
    }

    #openAndFocus(item, position) {
      this.#closeSiblings(item);
      this.#setExpanded(item, true);
      const focusable = this.#getFocusable(
        item.querySelector(":scope > .gm-submenu"),
      );
      (position === "last" ? focusable.at(-1) : focusable[0])?.focus();
    }

    #closeSiblings(item) {
      item.parentElement
        ?.querySelectorAll(":scope > .gm-has-submenu.gm-kb-open")
        .forEach((sibling) => {
          if (sibling !== item) {
            this.#setExpanded(sibling, false);
          }
        });
    }

    #handleTopLevelKeys(e, link) {
      const item = link.parentElement;
      const hasSubmenu = item.classList.contains("gm-has-submenu");
      const targets = this.#topLevelTargets();

      switch (e.key) {
        case "ArrowDown":
        case "ArrowUp":
          if (!hasSubmenu) {
            return;
          }
          e.preventDefault();
          this.#openAndFocus(item, e.key === "ArrowUp" ? "last" : "first");
          return;

        case "ArrowRight":
        case "ArrowLeft": {
          if (targets.length < 2) {
            return;
          }
          e.preventDefault();
          this.#setExpanded(item, false);
          const step = e.key === "ArrowRight" ? 1 : -1;
          const index = targets.indexOf(link);
          targets[(index + step + targets.length) % targets.length].focus();
          return;
        }

        case "Home":
        case "End":
          if (!targets.length) {
            return;
          }
          e.preventDefault();
          this.#setExpanded(item, false);
          (e.key === "Home" ? targets[0] : targets.at(-1)).focus();
      }
    }

    #handleSubmenuKeys(e) {
      const layer = e.target
        .closest(".gm-level-0.gm-has-submenu.gm-kb-open")
        ?.querySelector(":scope > .gm-submenu");
      if (!layer) {
        return;
      }

      if (e.key === "ArrowLeft") {
        const item = e.target.closest(".gm-has-submenu.gm-kb-open");
        if (!item) {
          return;
        }
        e.preventDefault();
        this.#closeAndRefocus(item);
        return;
      }

      if (e.key === "ArrowRight") {
        const link = e.target.closest(".gm-has-submenu > .gm-target");
        if (!link) {
          return;
        }
        e.preventDefault();
        this.#openAndFocus(link.parentElement, "first");
        return;
      }

      const focusable = this.#getFocusable(layer);
      if (!focusable.length) {
        return;
      }

      switch (e.key) {
        case "ArrowDown":
        case "ArrowUp": {
          e.preventDefault();
          const index = focusable.indexOf(e.target);
          if (index === -1) {
            focusable[0].focus();
            return;
          }
          const step = e.key === "ArrowDown" ? 1 : -1;
          focusable[
            (index + step + focusable.length) % focusable.length
          ].focus();
          return;
        }

        case "Home":
          e.preventDefault();
          focusable[0].focus();
          return;

        case "End":
          e.preventDefault();
          focusable.at(-1).focus();
      }
    }

    #attachDelegatedListeners() {
      // Tab wird bewusst nicht abgefangen: laut Disclosure-Pattern verlaesst der
      // Fokus den Layer und schliesst ihn (siehe focusout-Handler unten).
      this.addEventListener("keydown", (e) => {
        if (e.altKey || e.ctrlKey || e.metaKey) {
          return;
        }

        if (e.key === " " || e.key === "Spacebar") {
          const link = e.target.closest(".gm-has-submenu > .gm-target");
          if (!link) {
            return;
          }
          // verhindert Seiten-Scroll und Link-Aktivierung
          e.preventDefault();

          const item = link.parentElement;
          const willOpen = !item.classList.contains("gm-kb-open");

          this.#closeSiblings(item);
          this.#setExpanded(item, willOpen);
          return;
        }

        if (e.key === "Escape") {
          const item = e.target.closest(".gm-has-submenu.gm-kb-open");
          if (!item) {
            return;
          }
          e.preventDefault();
          this.#closeAndRefocus(item);
          return;
        }

        if (e.target.closest("input, textarea, select, [contenteditable]")) {
          return;
        }

        const topLevelLink = e.target.closest(".gm-level-0 > .gm-target");
        if (topLevelLink) {
          this.#handleTopLevelKeys(e, topLevelLink);
          return;
        }

        if (e.target.closest(".gm-submenu")) {
          this.#handleSubmenuKeys(e);
        }
      });

      // focusout: feuert wenn Fokus das Element oder Kinder verlässt
      this.addEventListener("focusout", (e) => {
        const item = e.target.closest(".gm-has-submenu.gm-kb-open");
        if (!item || item.contains(e.relatedTarget)) {
          return;
        }
        this.#setExpanded(item, false);
      });

      // Hover: aria-expanded für Maus-Nutzer aktualisieren
      this.addEventListener("mouseover", (e) => {
        const item = e.target.closest(".gm-level-0.gm-has-submenu");
        if (!item || item.contains(e.relatedTarget)) {
          return;
        }
        item
          .querySelector(":scope > .gm-target")
          ?.setAttribute("aria-expanded", "true");
      });

      this.addEventListener("mouseout", (e) => {
        const item = e.target.closest(".gm-level-0.gm-has-submenu");
        if (!item || item.contains(e.relatedTarget)) {
          return;
        }
        if (
          item.classList.contains("gm-kb-open") ||
          item.contains(document.activeElement)
        ) {
          return;
        }
        item
          .querySelector(":scope > .gm-target")
          ?.setAttribute("aria-expanded", "false");
      });
    }
  }

  customElements.define("main-navigation", MainNavigation);
}
